import React from 'react';
import { observer } from 'mobx-react-lite';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  CHIP_ICON_POSITION,
  CHIP_SIZE,
  CHIP_TYPE,
  FILES_LIST_TYPE,
  ICON_SIZE,
  TAB_BUTTON_TYPE
} from '../../../global/constants';
import { isEmpty } from '../../../helpers/common';
import { fileOrderingMenuItems } from '../../../global/row';
import { AccountingData } from '../../../hooks/accounting/useAccountingData';
import { Dropdown, DropdownItem } from '../../dropdown';
import Chip from '../../chipComponent';
import Tabs from '../../tabs';
import { Data, DropText, FileDropdown, GroupDiv, Options, SVGDiv, TaskDrop, TaskFilterDiv } from '../styles';

interface FileFilterDropdownContentProps {
  accounting: AccountingData;
}

const FileFilterDropdownContent: React.FC<FileFilterDropdownContentProps> = observer(({ accounting }) => {
  const { currentProject, filesViewListType, menus, onChangeFileOrdering, onChangeFilesListType } = accounting;
  const fileTabs = [
    {
      key: FILES_LIST_TYPE.GRID,
      title: 'Grid',
      iconName: 'board-view-icon',
      isActive: filesViewListType === FILES_LIST_TYPE.GRID || isEmpty(filesViewListType)
    },
    {
      key: FILES_LIST_TYPE.LIST,
      title: 'List',
      iconName: 'list-view-icon',
      isActive: filesViewListType === FILES_LIST_TYPE.LIST
    }
  ];

  return (
    <FileDropdown>
      <TaskDrop>
        <Data>
          <Options>
            {fileTabs.map((tab) => (
              <Tabs
                key={tab.key}
                variant={TAB_BUTTON_TYPE.STANDARD}
                applyFullWidth={true}
                size='small'
                title={tab.title}
                isActive={tab.isActive}
                onClick={() => onChangeFilesListType(tab.key)}
                iconName={tab.iconName}
                iconPosition='start'
              />
            ))}
          </Options>
        </Data>
      </TaskDrop>
      <TaskFilterDiv>
        <Data>
          <GroupDiv>
            <SVGDiv>
              <SVGIcon
                name='small-filters-icon'
                width={ICON_SIZE.SM}
                height={ICON_SIZE.SM}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                className='file-filters'
              />
            </SVGDiv>
            <DropText>Ordering</DropText>
          </GroupDiv>
          <Dropdown
            modalTitle='Ordering'
            content={
              <Chip
                variant={CHIP_TYPE.FILL}
                size={CHIP_SIZE.SMALL}
                title={
                  fileOrderingMenuItems.find((item) => item.key === currentProject?.fileOrdering)?.label ||
                  'Date uploaded'
                }
                onClick={() => menus.setIsFileOrderDropdownOpen(!menus.isFileOrderDropdownOpen)}
                isActive={menus.isFileOrderDropdownOpen}
                trailingIconName='down-arrow-icon'
                trailingIconClassName={menus.isFileOrderDropdownOpen ? 'dropdown-icon' : ''}
                iconPosition={CHIP_ICON_POSITION.TEXT_RIGHT_BUTTON}
              />
            }
            trigger='click'
            onOutsideClick={() => menus.setIsFileOrderDropdownOpen(false)}>
            {fileOrderingMenuItems.map((item) => (
              <DropdownItem
                key={item.key}
                label={item.label}
                isActive={currentProject?.fileOrdering === item.key}
                onClick={() => onChangeFileOrdering(item.key)}
              />
            ))}
          </Dropdown>
        </Data>
      </TaskFilterDiv>
    </FileDropdown>
  );
});

export default FileFilterDropdownContent;
